import { Box, Typography } from '@mui/material';

const EventInfoFragment = ({ label, body, isMobile, justified }) => {
  return (
    <Box display={'flex'} flexDirection={'column'} marginTop={'1rem'}>
      <Box>
        <Typography
          variant={isMobile ? 'h6' : 'h5'}
          component={'span'}
          style={{
            marginBottom: '.5rem',
            fontWeight: '700',
          }}
        >
          {label}
        </Typography>
      </Box>

      <Box>
        <Typography
          variant={isMobile ? 'body2' : 'h6'}
          sx={{ whiteSpace: 'pre-wrap' }}
          align={justified ? 'justify' : 'left'}
        >
          {body}
        </Typography>
      </Box>
    </Box>
  );
};

export default EventInfoFragment;
